module.exports = __webpack_public_path__ + "img/output_12.fa506d6e.png";